<template lang="pug">
  header
    .header-inner
      #logo
        a(href="/index.html", data-mypid="1928")
          img(src="@/assets/_src/46634/157095208735801.png?v=1664435496982", id="imgsrc46634_1", class=" c-no_adjust")
      span.burger-btn(@click="menuOpen = !menuOpen")
        span
        span
        span
      nav(:class="{ 'is-open': menuOpen }")
        ul.nav-list
          li.m-sm.burger-close(@click="menuOpen = !menuOpen")
          li.c-current
            a(href="/generally/", data-mypid="1952", ) HOME
          li
            a(href="/clinic/", ) クリニックを探す
          li
            a(href="#", class=" js-link_scroller") PRODUCTS
            ul
              li
                div(class="c-img js-mouse_overs")
                  a(href="/generally/dionavi.html", data-pid="1962")
                    img.off(src="@/assets/_src/f_nav_dionavi.png?v=1694271492633", id="imgsrc45736_1")
                    img.on(src="@/assets/_src/f_nav_dionavi_on.png?v=1694271492633", id="imgsrc47323_2", class=" js-over_img")
              li
                div(class="c-img js-mouse_overs")
                  a(href="/generally/fullarch.html", data-pid="1961")
                    img.off(src="@/assets/_src/f_nav_dionavi_fullarch.png?v=1694271492633", id="imgsrc45738_1")
                    img.on(src="@/assets/_src/f_nav_dionavi_fullarch_on.png?v=1694271492633", id="imgsrc47324_2", class=" js-over_img")
              li
                div(class="c-img js-mouse_overs")
                  a(href="https://ortho.diodigital.co.jp/", target="_blank", class=" js-link_scroller")
                    img.off(src="@/assets/_src/f_nav_orthonavi.png?v=1694271492633", id="imgsrc53934_1")
                    img.on(src="@/assets/_src/f_nav_orthonavi_on.png?v=1694271492633", id="imgsrc53936_2", class=" js-over_img")
          li
            a(href="/generally/companydata.html", data-pid="1953", ) 企業情報
          li
            a(href="/generally/recruit.html", data-pid="1958", ) 採用情報
          li
            a(href="/generally/faq.html", data-pid="1957", ) FAQ
          li
            a(href="/generally/contact.html", data-pid="1956", ) お問い合わせ

</template>
<script>
//-import lib from "@/assets/_module/lib/lib.js";
//-import bind from "@/assets/_module/scripts/bind.js";
export default {
  name: "headerC",
  data: function () {
    return {
      menuOpen: false,
    };
  },
  methods: {
    init() {
      //-bind.init();
    },
  },
};
</script>

<style scoped lang="scss">
@use "@/css/utility/_colors" as colors;
@use "@/css/utility/_mixin" as mixin;
@use "@/css/utility/_media" as media;
@use "@/css/utility/_font" as font;
@use "@/css/utility/_variables" as variables;

header {
  background: #141414;
  width: 100%;
  //@include mixin.liquidSize(height, 60, 60);
  position: fixed;
  box-sizing: border-box;
  line-height: 1.9;
  z-index: 10;
  box-sizing: border-box;
  font-weight: 400; /* regular */
  * {
    box-sizing: border-box;
  }
  @include media.max-screen(media.$breakpoint-sm) {
    height: 53px;
  }
  @include media.min-screen(media.$breakpoint-md) {
    height: 60px;
    a:hover {
      opacity: 0.4;
    }
  }
}

.burger-btn {
  @include media.max-screen(media.$breakpoint-sm) {
    background-color: rgba(0, 0, 0, 0);
    margin-top: 5px;
    margin-right: 5px;
    border-style: none;
    margin-bottom: 0px;
    position: fixed;
    top: 0;
    right: 0;
    width: 48px;
    height: 48px;
    display: block;
    span {
      border: solid 1px #ffffff;
      position: absolute;

      left: 7px;
      width: 32px;
      &:nth-child(1) {
        top: 11px;
      }
      &:nth-child(2) {
        top: 21px;
      }
      &:nth-child(3) {
        top: 31px;
      }
    }
  }
}

.header-inner {
  @include media.min-screen(media.$breakpoint-md) {
    display: flex;
  }
}

#logo {
  @include media.max-screen(media.$breakpoint-sm) {
    width: 50%;
    padding-top: 10px;
    padding-left: 15px;
    margin-bottom: 0px;
    padding-bottom: 10px;
    margin-right: 2%;
  }
  @include media.min-screen(media.$breakpoint-md) {
    width: 18% !important;
    padding-top: 11px;
    padding-left: 30px;
    margin-bottom: 10px;
    margin-right: 2%;
  }
  img {
    @include media.max-screen(media.$breakpoint-sm) {
      width: 100%;
    }
    @include media.min-screen(media.$breakpoint-md) {
      width: 181px;
    }
  }
}

nav {
  @include media.max-screen(media.$breakpoint-sm) {
    background-color: #1e1e1e;
    margin-left: 40%;
    width: 60%;
    padding-left: 15px;
    height: 100%;
    position: fixed;
    top: 0;
    bottom: 0;
    z-index: 9000;
    left: 100%;
    //
    transition: left 0.5s ease-in-out;
    &.is-open {
      display: block;
      left: 0px;
    }
  }
  @include media.min-screen(media.$breakpoint-md) {
    width: 78% !important;
    padding-top: 20px;
    padding-bottom: 15px;
    margin-left: 2%;
  }
}

.burger-close {
  position: relative;
  padding-top: 7px;
  padding-bottom: 7px;
  margin-right: 7px;
  padding-right: 7px;
  width: 100%;
  height: 60px;
  &:before,
  &:after {
    content: "";
    width: 17px;
    height: 2px;
    background: #b3b3b3;
    position: absolute;
    top: 34px;
  }
  &:before {
    rotate: 45deg;
    transform-origin: bottom right;
    right: 16px;
  }
  &:after {
    rotate: -45deg;
    transform-origin: bottom left;
    right: 10px;
  }
}
.nav-list {
  @include media.min-screen(media.$breakpoint-md) {
    display: flex;
  }
  > li {
    @include media.max-screen(media.$breakpoint-sm) {
      letter-spacing: 2.4px;
      color: #b3b3b3;
      font-size: 13px;
      width: 100%;
      display: block;
      padding-top: 7px;
      padding-bottom: 7px;
    }
    @include media.min-screen(media.$breakpoint-md) {
      margin-left: 20px;
      margin-right: 20px;
      float: left;
      position: relative;
      z-index: 1;
      &:hover {
        ul {
          height: auto;
          li {
            &:first-child {
              &:before {
                display: block;
              }
            }
            a {
              height: auto;
              opacity: 1;
              padding: 10px 5px;
              border-bottom: 1px solid #fff;
            }
          }
        }
      }
    }
  }
  li {
    @include media.max-screen(media.$breakpoint-sm) {
      li {
        padding-top: 7px;
        padding-bottom: 7px;
        padding-left: 20px;
        margin-left: 1px;
      }
      a {
        img {
          &.on {
            display: none;
          }
        }
      }
    }
    @include media.min-screen(media.$breakpoint-md) {
      margin-left: 20px;
      margin-right: 20px;
      float: left;
      position: relative;
      letter-spacing: 2.4px;
      color: #b3b3b3;
      font-size: 13px;
      > ul {
        width: 150px;
        position: absolute;
        left: 50%;
        margin-left: -75px;
        &:before {
          content: "";
          position: absolute;
          width: 0;
          height: 0;
          border: 5px solid transparent;
          top: 0;
          left: 50%;
          margin-left: -5px;
          border-top-color: #999;
        }
        li {
          margin-right: -30px;
          margin-left: -30px;
          color: #000000;
          display: block;
          float: none;
          //margin-left: 0;
          padding: 0;
          &:first-child {
            padding-top: 15px;
            &:before {
              content: "";
              position: absolute;
              width: 0;
              height: 0;
              border: 7px solid transparent;
              border-bottom-color: #ddd;
              top: 2px;
              left: 50%;
              margin-left: -7px;
              display: none;
            }
          }
          a {
            display: block;
            background-color: #ddd;
            border-bottom: 1px solid #eee;
            font-weight: 400;
            text-align: center;
            height: 0;
            padding: 0;
            opacity: 0;
            -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";
            overflow: hidden;
            white-space: normal;
            word-wrap: break-word;
            transition-property: all;
            transition-duration: 0.2s;
            transition-timing-function: ease-in-out;
            color: #000;
            img {
              &.on {
                display: none;
              }
            }
            &:hover {
              background-color: #d1d1d1;
              border-style: none;
              opacity: 1;
              img {
                &.off {
                  display: none;
                }
                &.on {
                  display: inline-block;
                }
              }
            }
          }
        }
      }
      &:hover {
        > ul {
        }
      }
    }
  }
  a {
    color: #c5c5c5;
    letter-spacing: 2.3px;
    font-size: 13px;
    font-weight: 500; /* medium */
  }
}
</style>
